import { useState, useEffect, useContext } from 'react'
import {UserContext} from "../../../context/userContext";
import { useFeature, FEATURES } from "../../../context/FeaturesContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRecycle, faSearch, faSync } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import '../../../assets/css/candidates_for.css';
import { listFilter, THROTTLE_TIME_TEN_SECONDS } from '../../../helpers/constants';

export const Filters = ({ changeSelectFilter, filtered, searchNameOrAdviser, handleClearFilters, isClearDisabled, handleRefresh, appliedSearch, userTypeFilter, changeUserTypeFilter }) => {

    const { userData } = useContext(UserContext)
    const subProspectsEnabled = useFeature(FEATURES.SUBPROSPECTS)

    const [filterListBy, setFilterListBy] = useState('');
    const [isThrottled, setIsThrottled] = useState(false);

    const handleThrottledRefresh = () => {
        if (isThrottled) {
            return;
        }

        setIsThrottled(true);
        handleRefresh();

        setTimeout(() => {
            setIsThrottled(false);
        }, THROTTLE_TIME_TEN_SECONDS);
    };


    const handleChange = async (e) => { 
        const value = e.target.value;
        setFilterListBy(value);
        if (value.trim() === '' && appliedSearch) {
            searchNameOrAdviser('');
        }
    }

    useEffect(() => {
        if (isClearDisabled) {
            setFilterListBy('');
        }
    }, [isClearDisabled]);

    // Si la búsqueda se quita desde afuera (chip, tachito, cambio de UDN), vaciar el input
    useEffect(() => {
        if (!appliedSearch) {
            setFilterListBy('');
        }
    }, [appliedSearch]);

    const visibleFilters = listFilter.filter(option => {
        if (option.id === 12) {
            return userData?.business_id === 3;
        }
        return true;
    });

    return (
        <div className="row" id="container_filters">
            <div className="col-md-6 justify-content-start" id="container_filter_by">
                <span className="label_filter blue_title">Filtrar por</span>
                <select
                    name="select_filter_by"
                    id="select_filter_by"
                    value={filtered}
                    onChange={(e) => changeSelectFilter(e)}
                >
                    <option value=""> Todos los candidatos por Estado</option>
                    {visibleFilters.map((option, index) => {
                        return (
                            <option key={index} value={option.prospect} className="blue_data">
                                {option.name}
                            </option>
                        );
                    })}
                </select>
                {subProspectsEnabled && (
                    <>
                        <span className="label_filter blue_title" style={{ marginLeft: "25px" }}>Ver</span>
                        <div style={{ marginLeft: "10px" }}>
                            <select
                                name="select_user_type_filter"
                                id="select_user_type_filter"
                                value={userTypeFilter}
                                onChange={(e) => changeUserTypeFilter(e)}
                            >
                                <option value="">Usuarios y subusuarios</option>
                                <option value="users">Solo usuarios</option>
                                <option value="subusers">Solo subusuarios</option>
                            </select>
                        </div>
                    </>
                )}
            </div>

            <div className="col-md-6" id="conent_filter_list_by">
                    <div className="d-flex" style={{gap: "10px", marginRight: "20px"}}>
                        <input
                            type="text"
                            value={filterListBy}
                            name="input_filter_by"
                            id="input_filter_by"
                            placeholder="Filtrar el listado por..."
                            onChange={(e) => handleChange(e)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    searchNameOrAdviser(filterListBy);
                                }
                            }}
                            className="w-100"
                        />
                        <div
                            style={{ margin: "0 10px", cursor: "pointer" }}
                            onMouseDown={() => searchNameOrAdviser(filterListBy)}
                        >
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                        <div className='d-flex' style={{gap: "10px"}}>
                            <Button
                                variant="outline-secondary"
                                className={isClearDisabled ? "clear-filters-btn" : "clear-filters-btn active"}
                                onClick={handleClearFilters}
                                disabled={isClearDisabled}
                                title='Presioná para borrar los filtros aplicados'
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </Button>
                            
                            <div title={isThrottled ? 'Aguardá unos segundos para volver a actualizar' : 'Hacé clic para refrescar la lista'}>
                            
                            <Button
                                variant="outline-secondary"
                                className={isThrottled ? "clear-filters-btn" : "clear-filters-btn active"}
                                onClick={handleThrottledRefresh}
                                disabled={isThrottled}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </div>
                    </div>
            </div>
        </div>
    )
}
